'use client';

import { useEffect } from 'react';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import BookingFlowModuleList, {
  BookingFlowModule,
} from '@/components/utilities/content-modules/booking-flow-module-list/booking-flow-module-list';
import { Module } from '@/components/utilities/content-modules/module-list/module-list';
import Row from '@/components/utilities/row/row';
import {
  trackPageLoadEvent,
  trackViewEvent,
} from '@/integrations/tracking/google-tag-manager/scripts';
import { tealiumView } from '@/integrations/tracking/tealium/scripts';
import styles from './my-trip-webview.module.scss';

export interface MyTripWebViewProps {
  /** An array of the content modules to show */
  contentModules: Module[];
  /** Personalization data for the user */
  personalizationData?: Content.Properties.PersonalizationData;
  /** Tracking data for the page */
  trackingData?: Content.Properties.TrackingData;
}

const MyTripWebView = ({
  contentModules,
  personalizationData,
  trackingData,
}: MyTripWebViewProps) => {
  useEffect(() => {
    trackPageLoadEvent({ content_group: 'my_trip_webview' });

    personalizationData && tealiumView(personalizationData);

    if (!trackingData?.gtmDataLayer) return;

    trackViewEvent(trackingData.gtmDataLayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.component}>
      <Container>
        <Row>
          <Column>
            <BookingFlowModuleList
              contentModules={contentModules as unknown as BookingFlowModule[]}
            />
          </Column>
        </Row>
      </Container>
    </div>
  );
};

MyTripWebView.displayName = 'MyTripWebView';

export default MyTripWebView;
